export default "/build/assets/icon-floatingbutton-camera.76c2418191a744d9a8a978d3ce096ea8.svg";